import WRAP from "WRAP-JS";

/* eslint-disable */
Object.assign(WRAP.Geo.Cache, {
    image: function(url, view) {
        if ( !url || this.imageError[url] )
            return null;
        var c = this.imageCache[url];
        if ( c == undefined ) {
            c = this.imageCache[url] = { loaded:false, image:new Image(), url:url };
            // c.image.crossOrigin = "use-credentials"; // "anonymous";
            c.image.crossOrigin = "anonymous";
            c.image.onload = function() {
                c.loaded = true;
                for ( var i = 0 ; i < view.layers.length ; i++ ) {
                    var layer = view.layers[i];
                    for ( var j = 0 ; j < layer._dl.length ; j++ ) {
                        var feature = layer._dl[j];
                        if ( feature.image == url || feature.strokeImage == url ) {
                            view.clearDisplayCache(layer._dc);
                            layer._dc = {};
                            view.invalidate();
                            break;
                    }
                    }
                }
            };
            c.image.onerror = function() {
                WRAP.Geo.Cache.imageError[c.url] = true;
                view.updateLayerStatus();
            }
            c.image.src = url;
        }
        else if ( c.loaded ) {
            return c.image;
        }
        return null;
    },
});
/* eslint-enable */
